import Logo from '@/components/Logo'
import Account from '@/sinister/header/components/Account'
import Cart from '@/sinister/header/components/Cart'
import Categories from '@/sinister/header/components/Categories'
import Favorites from '@/sinister/header/components/Favorites'
import MoreAbout from '@/sinister/header/components/MoreAbout'
import OpModel from '@/sinister/header/components/OpModel'
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Search from '@mercadoni/sinister/dist/cjs/search'
import { Suspense } from 'react'
import styled from 'styled-components'

const StyledGrid = styled.header`
  display: grid;
  grid-template-areas:
    'main'
    'secondary';
  grid-template-rows: 66px 36px;
  line-height: normal;
  .header {
    &__main {
      grid-area: main;
      background-color: var(
        --app-header-background-mobile-v3,
        var(--app-header-background-mobile)
      );
      padding: 18px;
      display: grid;
      gap: 16px;
      grid-template-areas: 'categoryTree logo icons';
      grid-template-columns: 30px 1fr auto;
      align-items: center;
      text-align: center;

      @media screen and (max-width: 360px) {
        padding: 18px 12px 18px 6px;
        gap: 8px;
      }
    }
    &__secondary {
      grid-area: secondary;
      background-color: var(
        --app-subheader-background-mobile-v3,
        var(--app-subheader-background-mobile)
      );
      display: grid;
      grid-template-areas: 'opModel moreAbout';
      ${(props: { langEnable: boolean }) =>
        props?.langEnable
          ? `grid-template-areas: 'opModel moreAbout language';`
          : `grid-template-areas: 'opModel moreAbout';`}
      justify-content: space-between;
    }

    &__icons {
      grid-area: icons;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
      @media screen and (max-width: 360px) {
        gap: 8px;
      }
    }

    &__logo {
      max-height: 30px;
    }

    &__search {
      line-height: 100%;
      cursor: pointer;
    }
  }
`

const LayoutA = () => {
  const {
    store: { reference },
    langConfig,
    initialSearchValue,
    clientId,
    onClickSearch,
    onClickSuggested,
    placeholder,
    pathname,
    enabledSearchAutocomplete,
    initialCategories,
    logo,
    slug,
    domain,
  } = useHeaderContext()

  return (
    <StyledGrid className="header" langEnable={langConfig?.enabled || false}>
      <div className="header__main">
        <Categories
          className="header__categoryTree"
          initialCategories={initialCategories}
        />
        <Logo
          className="header__logo"
          src={logo}
          slug={slug}
          domain={domain}
          height={30}
        />
        <div className="header__icons">
          <Suspense fallback="">
            <Search
              enabledSearchAutocomplete={enabledSearchAutocomplete}
              className="header__search"
              storeReference={reference}
              initialValue={initialSearchValue}
              clientId={clientId}
              onClickSearch={onClickSearch}
              onClickSuggested={onClickSuggested}
              placeholder={placeholder}
              pathname={pathname}
            />
          </Suspense>
          <Favorites />
          <Account />
          <Cart />
        </div>
      </div>
      <div className="header__secondary">
        <OpModel />
        <MoreAbout />
      </div>
    </StyledGrid>
  )
}

export default LayoutA
